import { useFirebaseAuth } from "../hooks/useFirebaseAuth";
import { GoogleAnalytics } from "./GoogleAnalytics/GoogleAnalytics";
import { Navigator } from "../Navigator";
import { LoadingComponent } from "./LoadingComponent";
import React, { useEffect } from "react";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import Gleap from "gleap";

export const AppContent = () => {
  useEffect(() => {
    Gleap.initialize("feDBOoD0MWjw1TicpkqdAV365dXKQsf4");

    Sentry.init({
      dsn: "https://d3545155bdb942c2bd23b0c09cb3acd7@o1144911.ingest.sentry.io/6209407",
      integrations: [new BrowserTracing()],

      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 1.0,
      environment: window.location.hostname,
    });
  }, []);
  const firebaseAuthIsLoaded = useFirebaseAuth();

  return (
    <>
      <GoogleAnalytics />
      {firebaseAuthIsLoaded ? <Navigator /> : <LoadingComponent />}
    </>
  );
};
